import Vue from 'vue'
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Meta from 'vue-meta'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import VeeValidate from 'vee-validate'
import VueFlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VModal from 'vue-js-modal'
import TopBar from '../components/TopBar'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import { VueEditor } from 'vue2-editor'
import LoadingButton from '../components/LoadingButton'
import LoadingSpinner from '../components/LoadingSpinner'
import 'vue-select/dist/vue-select.css'
import VueSignaturePad from 'vue-signature-pad'

require('./bootstrapvue')
require('./fontawesome')

Vue.use(VueSignaturePad)
Vue.use(VueGoodTablePlugin)

Vue.use(VueSweetalert2)

Vue.use(Meta)

Vue.component('loading-button', LoadingButton)
Vue.component('loading-spinner', LoadingSpinner)

Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  errorBagName: 'errors'
})

Vue.use(VueFlatPickr)

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightBottom
  }
})

Vue.use(VModal, { dynamic: true })

Vue.component('top-bar', TopBar)

Vue.component('v-select', vSelect)

Vue.component('draggable', draggable)

Vue.use(require('vue-truncate-filter'))

Vue.component('vue-editor', VueEditor)

const moment = require('moment')
moment.locale('en_AU')

Vue.use(require('vue-moment'), { moment })

const dateOptions = {
  altFormat: 'd-m-Y',
  altInput: true,
  dateFormat: 'Y-m-d H:i:S',
  parseDate: (date) => {
    return new Date(date)
  }
}
Vue.prototype.$dateOptions = dateOptions
